module.exports = __webpack_public_path__ + "img/banner-classroom.39c1d913.png";